import type { UseQueryResult } from '@tanstack/react-query/src/types';
import { useCustomerGeoLocation } from '../../hooks/useCustomerGeoLocation';
import { useNearestStoreByLocation } from './useNearestStoreByLocation';
import type { Store } from './model';

export const useCustomerGeoLocationStore = (): UseQueryResult<Store | null> => {
    const { data } = useCustomerGeoLocation();
    return useNearestStoreByLocation(data);
};
